<template>
  <k-dialog
    @close="cancel"
    :max-width="400"
    :title="dialogTitle"
  >
    <form class="k-form" @submit.prevent="save">
      <div style="width: 50vw">
         <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
             External Provider :
          </label>
          <div class="col-sm-9">
            <select class="form-control"  
             v-model="providerInEdit.predefinedType"
             required
            >
            <option v-for="provider in providerTypes" :key="provider" :value="provider">
              {{provider}}
            </option>
            </select>
            
          </div>
        </div>
<div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">Name:</label>

          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'Name'"
              :placeholder="'Name'"
              v-model="providerInEdit.name"
              class="form-control"
              required
            ></k-input>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">displayName:</label>

          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'displayName'"
              :placeholder="'displayName'"
              v-model="providerInEdit.displayName"
              class="form-control"
              required
            ></k-input>
          </div>
        </div>
      <div class="form-group row" :style="{ marginBottom: '1rem' }">
            <label class="col-sm-3 text-left col-form-label">
              Tenant Logo :
            </label>
            <div class="col-sm-6">
              <input
                type="file"
                ref="file"
                @change="onLogoChange"
                class="imageButton"
                accept="image/*"
              />
            </div>
          </div>

          <p class="col-sm-6 offset-sm-3" v-if="logoName">{{ logoName }}</p>
      </div>
      
      <input type="submit" id="submit-form" class="d-none" />
    </form>

    <div class="d-flex ">
      <button class="k-button col-6" @click="cancel" >Cancel</button>
      <label class="k-button k-primary col-6 mb-0" for="submit-form" tabindex="0"
        >Save</label
      >
    </div>
  </k-dialog>
</template>
<script>
import { Dialog, DialogActionsBar } from "@progress/kendo-vue-dialogs";
import { NumericTextBox, Input } from "@progress/kendo-vue-inputs";
import { oidcSettings } from "../../services/store";
import "@progress/kendo-ui/js/kendo.core";
import "@progress/kendo-ui/js/kendo.data";

export default {
  components: {
    "k-input": Input,
    numerictextbox: NumericTextBox,
    "k-dialog": Dialog,
    "dialog-actions-bar": DialogActionsBar,
  },
  props: {
    dataItem: Object,
    dialogTitle: String,
    providerTypes:Array,
  },
  data: function () {
    return {
      providerInEdit: {
        predefinedType:"",
        displayName:"",
        name:"",
        logo:undefined,
      },
      logoName:undefined,
      base_url: undefined,
      action: "",
      messages: {
        checked: "Yes",
        unchecked: "No",
      },
    };
  },
  created: function () {
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";

    if (this.$props.dataItem) {
      this.providerInEdit = this.$props.dataItem;
      console.log(this.providerInEdit);
    } else {
      this.providerInEdit = {
        predefinedType:"",
        displayName:"",
        name:"",
      };
    }
  },
  mounted: function () {
  },

  computed: {
  },

  methods: {
    onLogoChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      console.log(files.length);
      this.providerInEdit.logo = files[0];
      this.logoName = files[0].name;
      console.log(this.providerInEdit.logo);
    },
    onChange() {
      console.log("changed");
    },
    cancel() {
      this.$emit("cancel");
    },
    save() {
        this.$emit("save");
    },
  },
};
</script>
<style scoped>

.imageButton {
  display: block;
  position: relative;
  width: 100%;
  margin: auto;
  cursor: pointer;
  border: 0;
  height: 30px;
  color: transparent;
  border-radius: 5px;
  outline: 0;
}
.imageButton:hover:after {
  background: #79ccf0;
}
.imageButton:after {
  transition: 200ms all ease;
  border-bottom: 3px solid rgba(0, 0, 0, 0.2);
  background: #f1f1f1;
  color: #000;
  font-size: 15px;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  content: "Upload Image";
  line-height: 30px;
  border-radius: 5px;
}
</style>